import EventEmitter from '../event-emitter';

const $ = jQuery;
export default class extends EventEmitter {
	VISIBLE_MENU_LI_CLASSES = ['et-show-dropdown', 'visible'];

	constructor(liDOM) {
		super();
		this.liDOM = liDOM;
		this.submenuDOM = $(liDOM)
			.children('ul');

		this.liObserver = new MutationObserver((mutationList) => {
			mutationList.forEach((mutation) => {
				if ((mutation.type === 'attributes') && (mutation.attributeName === 'class')) {
					if (this.hasClass(this.liDOM, mutation.oldValue, this.VISIBLE_MENU_LI_CLASSES)) {
						this.emit('show');
					} else if (this.hadClass(this.liDOM, mutation.oldValue, this.VISIBLE_MENU_LI_CLASSES)) {
						this.emit('hide');
					}
				}
			});
		});
	}

	connect() {
		this.liObserver.observe(this.liDOM, { attributes: true, attributeOldValue: true });
	}

	onShow(handler) {
		this.on('show', handler);
	}

	onHide(handler) {
		this.on('hide', handler);
	}

	hasClass(dom, oldValue, classes) {
		let result = false;
		if (!oldValue) {
			/* eslint-disable no-param-reassign */
			oldValue = '';
		}

		classes.forEach((currentValue) => {
			if (!oldValue.includes(currentValue) && dom.className.includes(currentValue)) {
				result = true;
			}
		});
		return result;
	}

	hadClass(dom, oldValue, classes) {
		let result = false;
		if (!oldValue) {
			/* eslint-disable no-param-reassign */
			oldValue = '';
		}
		classes.forEach((currentValue) => {
			if (oldValue.includes(currentValue) && !dom.className.includes(currentValue)) {
				result = true;
			}
		});
		return result;
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/submenu-observer.js